<template>
  <main-layout :showFooter="true">
    <div class="login-view">
      <div class="form-container">
        <img class="logo" src="/static/img/logo_cdtm.png" width="150px" alt="">
        <h1>Contacts</h1>
        <a-form
          id="view-login"
          :form="form"
          class="login-form"
          @submit.prevent="handleSubmit"
        >
          <p>
            Contacts is a read-only address book for Centerling's data that supports offline storage.
            You can add it to your home screen.
          </p>
          <p>
            You can login using your CDTM email address (firstname.lastname@cdtm.de).
          </p>
          <a-form-item>
            <a-input
              v-decorator="[
                'email',
                { rules: [{ required: true, message: 'Please input your email!' }] }
              ]"
              placeholder="Email"
            >
              <a-icon
                slot="prefix"
                type="user"
                style="color: rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'password',
                { rules: [{ required: true, message: 'Please input your Password!' }] }
              ]"
              type="password"
              placeholder="Password"
            >
              <a-icon
                slot="prefix"
                type="lock"
                style="color: rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>
          <div class="error">
            <span v-if="error">
              {{error}}
            </span>
            &nbsp;
          </div>
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
              class="login-form-button"
            >
              Log in
            </a-button>
            Or <a href="https://home.cdtm.de/index.php/login" target="_blank">reset password</a>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout.vue'

export default {
  components: {
    MainLayout
  },
  data () {
    return {
      error: null
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  mounted () {
    if (this.user) {
      let path = this.$route.query.redirect || '/'
      this.$router.push(path)
    }
  },
  watch: {
    user (newValue) {
      if (newValue) {
        let path = this.$route.query.redirect || '/'
        this.$router.push(path)
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    handleSubmit (e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.attemptLogin(values)
        }
      })
    },
    async attemptLogin (values) {
      try {
        await this.$store.dispatch('login', values)
        await this.$store.dispatch('fetchCurrentUser')
        await this.$store.dispatch('updateContactList')
      } catch (error) {
        this.error = error
      }
    }
  }
}
</script>
<style scoped>
.login-view {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
}
.form-container {
  margin-top: 5vh;
  display: inline-block;
}
.logo {
  margin: 20px 0;
}
.login-form {
  max-width: 300px;
}
.login-form-forgot {
  float: right;
}
.login-form-button {
  width: 100%;
}
.error {
  color: red;
  margin-bottom: 8px;
  margin-top: -12px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/Login.vue